<template lang="pug">
	.animated.fadeIn.preview-screen(ref="previewScreen" v-on:wheel="onWheel($event)" v-on:mousedown="onMouseDown($event)" :class="{'is-dragging': isDragging}")
		.preview-frame(ref="previewFrame" :style="dimensions" v-show="Creative.SelectedCreative && Version.SelectedVersion && Creative.isSelectedCreativeLoaded() && frameSrc" v-on:dragenter="onFrameDropDragEnter($event)" v-on:dragover="onFrameDropDragOver($event)" v-on:dragleave="onFrameDropDragLeave($event)" v-on:drop="onFrameDropDrop($event)")
			iframe(ref="iframe" :src="frameSrc" frameborder="0" :width="dimensions.width" :height="dimensions.height" allow='autoplay' allowfullscreen :style="{'pointer-events': (isDragging || showCtrlOverlay || frameDropDragActive) ? 'none' : 'auto'}" @load="onIframeLoaded")
			.preview-ctrl-overlay(v-if="showCtrlOverlay" v-on:wheel.prevent.stop="onOverlayWheel($event)" v-on:mousedown.prevent.stop="onOverlayMouseDown($event)")
			.preveiew-overlays(v-if="User.currentUser.Tags['admin'] && Layout.page === 'playables'")
				.iphone-x(v-if="Layout.previewDevice === 'iPhoneX'" :class="Layout.previewOrientation[Layout.previewDevice]")
		//- Оверлей перетаскивания ассетов и файлов во фрейм превью (см. PreviewFrameDrop.vue и Asset.FrameDrop.js)
		PreviewFrameDrop(v-if="frameDropOverlayText" :text="frameDropOverlayText" :overlay-style="frameDropOverlayStyle" :highlight-style="frameDropHighlightStyle")
		.no-version(:style="dimensions" v-show="Creative.SelectedCreative && !Version.SelectedVersion && Creative.isSelectedCreativeLoaded()")
			.text There are no selected version of the creative
		.preview-ctrl-instructions(v-if="showCtrlOverlay")
			.overlay-instruction
				.instruction-item
					.instruction-icon
						svg.mouse-icon(width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
							rect(x="6" y="3" width="12" height="18" rx="6")
							line(x1="12" y1="7" x2="12" y2="11")
					.instruction-text Scroll wheel to zoom
				.instruction-divider
				.instruction-item
					.instruction-icon
						i.fa.fa-arrows-alt
					.instruction-text Drag to move
</template>

<script>

	import Screen 						from './../../mixins/screen';
	import PreviewFrameDrop, { FrameDropFrame }	from './PreviewFrameDrop';

	import { User }						from '../../services/User'
	import { Publisher }				from '../../services/Publisher'
	import { Creative }					from '../../services/Creative'
	import { Version }					from '../../services/Version'
	import { Settings }					from '../../services/Settings'
	import { Asset }					from '../../services/Asset'
	import { Localization }				from '../../services/Localization'
	import { Layout } 					from './../../services/Layout'

	export default {
		name: 'Preview',
		mixins: [Screen, FrameDropFrame],
		screen: {
			updateOn: [
				"Layout Workspace Changed",
				"Aside State Changed",
				"Selected Version Switched",
				"Preview Zoom Changed",
				"Layout Page Changed",
				"AI Chat Height Changed"
			],
			events: {
				"Selected Version Switched,Selected Creative Fully Loaded": function() {

					if (Creative.isSelectedCreativeLoaded() && Version.SelectedVersion) this.refresh(10, true, true);

				},
				"Selected Creative Changed,Aside State Changed,Sub Aside State Changed,Preview Device Changed,Preview Orientation Changed,Preview Zoom Changed,Layout Page Changed,AI Chat Height Changed": function() {

					this.processFrameSize();

				},
				"Preview Drag State Changed": function(isDragging) {

					this.isDragging = isDragging;
					if (!isDragging) {
						this.dragStartedOnOverlay = false;
					}

				},
				"Preview Size Changed": function() {

					this.sendToIFramePreviewSize();

					this.processFrameSize();

				},
				// В версии добавили или удалили размер: список размеров тоже нужно передать в превью,
				// иначе оно продолжит считать масштаб по устаревшему banner-sizes
				"Selected Version Changed: [options.sizes]": function() {

					if (!Version.SelectedVersion) return;

					let sizes = Version.SelectedVersion.options.sizes || [];

					this.sendToIFramePreviewSize(sizes);

					this.processFrameSize();

				},
				"Pull Creative Done": function(pullCreativeId) {

					if (pullCreativeId === Creative.SelectedCreative.id) this.refresh(1000, true, true);

				},
				"Selected Version Setting Changed": function(settingCodename, value) {

					this.sendToIFrameSetting(settingCodename, value);

					if (settingCodename === "banner-width" || settingCodename === "banner-height") this.processFrameSize();

				},
				"Refresh Iframe": function() {

					this.refresh(10, true, false);

				},
				"Selected Banner Script Changed": function() {

					this.refresh(10, true, true);

				},
				"Selected Creative Renderer Script Changed": function() {

					this.refresh(1000, true);

				},
				"Selected Version Assets Changed,Selected Version Assets Restored,Selected Version Assets Deleted": function(...assetsData) {

					let message = {
						setAssets: {}
					};

					assetsData.forEach(assetData => {
						const versionId = assetData[0];
						const assetCodename = assetData[1];
						let version = Version.getVersion(versionId);
						let creative = Creative.getCreative(version?.creative_id) || Creative.SelectedCreative;
						let asset = Asset.getAsset(version, assetCodename);

						if (asset) message.setAssets[Asset.getMergedAssetCodename(asset)] = Asset.cleanVersionAsset(asset, Settings.getVersionSettingValue(versionId, 'separated-images-in-dashboard-preview'), creative);
						else message.setAssets[assetCodename] = null;
					});

					if (this.$refs?.iframe?.contentWindow) this.$refs.iframe.contentWindow.postMessage(message, '*');

					this.log(message);

				},
				"Localization Message Changed": function(locale, codename, text_message) {

					this.sendToIFrameLocalizationMessage(locale, codename, text_message);

				},
				"Localization Style Changed": function(locale, codename, style_name, style_value) {

					this.sendToIFrameLocalizationStyle(locale, codename, style_name, style_value);

				},
				"Version Elements Loaded": function(versionId) {

					if (versionId === Version.SelectedVersion?.id) this.sendToIFrameElements();

				},
				"IFrame Data:StartElementDrag,IFrame Data:StartElementScale,IFrame Data:StartElementAngle": function() {

					this.isElementEditing = true;

				},
				"IFrame Data:EndElementDrag,IFrame Data:EndElementScale,IFrame Data:EndElementAngle": function() {

					this.isElementEditing = false;

				},
				"Send To iFrame": function(data) {

					if (this.$refs?.iframe?.contentWindow) this.$refs.iframe.contentWindow.postMessage(data, '*');

					this.log(data);

				}
			}
		},
		components: {

			PreviewFrameDrop

		},
		data() {

			this.User = User;
			this.Publisher = Publisher;
			this.Creative = Creative;
			this.Settings = Settings;
			this.Layout = Layout;

			return {
				showed: true,
				isDragging: false,
				isCtrlPressed: false,
				isElementEditing: false,
				dragStartedOnOverlay: false,
				frameSrc: Settings.getFrameSrc(true),
				devices: {
					iPad: {
						width: 768,
						height: 1024,
						ratio: 4/3,
						text: ['4', '3']
					},
					iPhone: {
						width: 375,
						height: 667,
						ratio: 16/9,
						text: ['16', '9']
					},
					iPhoneX: {
						width: 375,
						height: 812,
						ratio: 19.5/9,
						text: ['19.5', '9']
					},
					square: {
						width: 1024,
						height: 1024,
						ratio: 1,
						text: ['1', '1']
					}
				},
				windowWidth: 0,
				windowHeight: 0,
				dimensions: {}
			};

		},
		computed: {
			showCtrlOverlay() {
				if (this.isElementEditing) return false;
				return this.isCtrlPressed || (this.isDragging && this.dragStartedOnOverlay);
			}
		},
		created() {

			window.addEventListener('resize', () => {

				this.windowWidth =  window.innerWidth;
				this.windowHeight = window.innerHeight;

				this.processFrameSize();

			});

			window.addEventListener("message", e => {

				if (e.data?.["BannerReady"]) this.sendToIFrameBannerInitData();

			});

			window.addEventListener("mousedown", e => {

				if (this.$refs?.iframe?.contentWindow) this.$refs.iframe.contentWindow.postMessage({press: true}, '*');

			});

			this.windowWidth =  window.innerWidth;
			this.windowHeight = window.innerHeight;

			this.processFrameSize();

		},
		mounted() {

			this._onKeyDown = (e) => {
				if (e.key === 'Control' || e.ctrlKey || e.key === 'Meta' || e.metaKey) {
					this.isCtrlPressed = true;
				}
			};

			this._onKeyUp = (e) => {
				if ((e.key === 'Control' || e.key === 'Meta') || (!e.ctrlKey && !e.metaKey)) {
					this.isCtrlPressed = false;
				}
			};

			this._onBlur = () => {
				this.isCtrlPressed = false;
				this.isElementEditing = false;
			};

			this._onMouseMove = (e) => {
				if (e.ctrlKey !== undefined || e.metaKey !== undefined) {
					this.isCtrlPressed = !!(e.ctrlKey || e.metaKey);
				}
			};

			this._onMouseUp = () => {
				this.isElementEditing = false;
			};

			window.addEventListener('keydown', this._onKeyDown);
			window.addEventListener('keyup', this._onKeyUp);
			window.addEventListener('blur', this._onBlur);
			window.addEventListener('mousemove', this._onMouseMove);
			window.addEventListener('mouseup', this._onMouseUp);

			this.onIframeLoaded();

		},
		beforeUnmount() {

			if (this._onKeyDown) window.removeEventListener('keydown', this._onKeyDown);
			if (this._onKeyUp) window.removeEventListener('keyup', this._onKeyUp);
			if (this._onBlur) window.removeEventListener('blur', this._onBlur);
			if (this._onMouseMove) window.removeEventListener('mousemove', this._onMouseMove);
			if (this._onMouseUp) window.removeEventListener('mouseup', this._onMouseUp);
			try {
				let cw = this.$refs?.iframe?.contentWindow;
				if (cw) {
					if (this._onKeyDown) cw.removeEventListener('keydown', this._onKeyDown);
					if (this._onKeyUp) cw.removeEventListener('keyup', this._onKeyUp);
					if (this._onBlur) cw.removeEventListener('blur', this._onBlur);
					if (this._onMouseUp) cw.removeEventListener('mouseup', this._onMouseUp);
				}
			} catch (e) {}

		},
		beforeDestroy() {

			if (this._onKeyDown) window.removeEventListener('keydown', this._onKeyDown);
			if (this._onKeyUp) window.removeEventListener('keyup', this._onKeyUp);
			if (this._onBlur) window.removeEventListener('blur', this._onBlur);
			if (this._onMouseMove) window.removeEventListener('mousemove', this._onMouseMove);
			if (this._onMouseUp) window.removeEventListener('mouseup', this._onMouseUp);
			try {
				let cw = this.$refs?.iframe?.contentWindow;
				if (cw) {
					if (this._onKeyDown) cw.removeEventListener('keydown', this._onKeyDown);
					if (this._onKeyUp) cw.removeEventListener('keyup', this._onKeyUp);
					if (this._onBlur) cw.removeEventListener('blur', this._onBlur);
					if (this._onMouseUp) cw.removeEventListener('mouseup', this._onMouseUp);
				}
			} catch (e) {}

		},
		methods: {
			refresh(timeout, force, reset_device_and_orientation) {

				clearTimeout(this.refreshTimeout);
				this.refreshTimeout = setTimeout(() => {

					this.frameSrc = Settings.getFrameSrc(force);

					this.$forceUpdate();

					if (reset_device_and_orientation) {

						Layout.setPreviewDeviceFromSettings();
						Layout.setPreviewOrientationFromSettings();

					}

				}, timeout || 1000);

			},
			processFrameSize() {

				if (!Creative.SelectedCreative || !Version.SelectedVersion) return;

				let proportions_width = 0,
					proportions_height = 0,
					top = 0;

				if (Creative.SelectedCreative.type === 'playable') {

					if (!Layout.previewDevice || !Layout.previewOrientation[Layout.previewDevice]) return;

					const proportions = this.devices[Layout.previewDevice];

					proportions_width = proportions.width * 1.2;
					proportions_height = proportions.height * 1.2;

				} else if (Creative.SelectedCreative.type === 'banner' || Creative.SelectedCreative.type === 'storyboard' || Creative.SelectedCreative.type === 'editable-playable' || Creative.SelectedCreative.type === 'end-card') {

					let sizes = Version.SelectedVersion.options.sizes || [],
						size = Layout.previewSize;

					if (!_.find(sizes, s => s.width === size?.width && s.height === size?.height)) {
						size = Layout.previewSize = sizes[0];
					}

					if (!size) size = {width: 320, height: 480};

					proportions_width = size.width;
					proportions_height = size.height;

				}

				let frame_width = window.innerWidth,
					frame_height = window.innerHeight;

				frame_height -= 54; //header
				frame_height -= 46; //devices
				if (Layout.getAIAgentHeight()) frame_height -= Layout.getAIAgentHeight(); //ai chat

				frame_width -= Layout.getCreativesPlaneWidth() + Layout.creativesVersionsPlaneWidth;

				let isModified = Layout.isPreviewZoomOrOffsetModified ? Layout.isPreviewZoomOrOffsetModified() : false;

				if (!isModified) {

					if (Layout.asideOpened) frame_width -= Layout.asideSize; //aside
					if (Layout.subAsideOpened) frame_width -= Layout.subAsideSize; //aside

				}

				if (Creative.SelectedCreative.type === 'playable' || Creative.SelectedCreative.type === 'end-card') {

					if (Layout.previewOrientation[Layout.previewDevice] === 'landscape') {

						[proportions_width, proportions_height] = [proportions_height, proportions_width];

					}

				}

				const screen_percent = 0.9;
				let scale = 1;

				if (proportions_height > frame_height * screen_percent) {

					let height_percent = frame_height * screen_percent / proportions_height;

					if (Creative.SelectedCreative.type === 'playable') {

						proportions_height = Math.floor(proportions_height * height_percent);
						proportions_width = Math.floor(proportions_width * height_percent);

					} else if (Creative.SelectedCreative.type === 'banner' || Creative.SelectedCreative.type === 'storyboard' || Creative.SelectedCreative.type === 'editable-playable' || Creative.SelectedCreative.type === 'end-card') {

						scale = Math.min(scale, height_percent);

					}

				}

				//console.log('proportions', proportions_width, proportions_height);

				if (proportions_width > frame_width * screen_percent) {

					let width_percent = frame_width * screen_percent / proportions_width;

					if (Creative.SelectedCreative.type === 'playable') {

						proportions_height = Math.floor(proportions_height * width_percent);
						proportions_width = Math.floor(proportions_width * width_percent);

					} else if (Creative.SelectedCreative.type === 'banner' || Creative.SelectedCreative.type === 'storyboard' || Creative.SelectedCreative.type === 'editable-playable' || Creative.SelectedCreative.type === 'end-card') {

						scale = Math.min(scale, width_percent);

					}

				}

				top = (frame_height - proportions_height) * 0.5;

				let finalScale = scale * (Layout.previewZoom || 1);
				let offsetX = Layout.previewOffset?.x || 0;
				let offsetY = Layout.previewOffset?.y || 0;

				this.dimensions = {
					width: Math.floor(proportions_width) + 'px',
					height: Math.floor(proportions_height) + 'px',
					marginTop: top + 'px',
					transform: `translate(${offsetX}px, ${offsetY}px) scale(${finalScale})`
				};

				//this.$forceUpdate();

			},
			onWheel(e) {

				if (this.isElementEditing) return;
				if (e.target.closest('iframe')) return;
				if (!e.ctrlKey && !e.metaKey && !this.isCtrlPressed) return;
				e.preventDefault();
				Layout.processPreviewZoomWheel(e);

			},
			onMouseDown(e) {

				if (this.isElementEditing) return;
				if (e.target.closest('iframe')) return;
				Layout.startPreviewDrag(e, { threshold: 20 });

			},
			onFrameMouseEnter() {

			},
			onFrameMouseLeave() {

			},
			onIframeLoaded() {

				try {
					let cw = this.$refs?.iframe?.contentWindow;
					if (cw) {
						cw.removeEventListener('keydown', this._onKeyDown);
						cw.removeEventListener('keyup', this._onKeyUp);
						cw.removeEventListener('blur', this._onBlur);
						cw.removeEventListener('mouseup', this._onMouseUp);
						cw.addEventListener('keydown', this._onKeyDown);
						cw.addEventListener('keyup', this._onKeyUp);
						cw.addEventListener('blur', this._onBlur);
						cw.addEventListener('mouseup', this._onMouseUp);
					}
				} catch (err) {}

				// Обработчики перетаскивания подключаются к документу превью: файлы из файловой системы
				// можно сбросить прямо над iframe (см. PreviewFrameDrop.vue)
				this.bindFrameDropFrameEvents();

			},
			onOverlayWheel(e) {

				if (this.isElementEditing) return;
				Layout.processPreviewZoomWheel(e);

			},
			onOverlayMouseDown(e) {

				if (this.isElementEditing) return;
				this.dragStartedOnOverlay = true;
				Layout.startPreviewDrag(e, { threshold: 20 });

			},
			sendToIFrameBannerInitData() {

				let message = {
					init: {
						Assets: Asset.cleanVersionAssets(Asset.getVersionAssets(Version.SelectedVersion), Creative.SelectedCreative),
						Settings: _.merge(Settings.getVersionSettings(Version.SelectedVersion), {"dashboard-preview-mode": true}),
						Localization: Localization.cleanVersionLocalization(Localization.getVersionLocalization(Version.SelectedVersion))
					}
				};

				if (this.$refs?.iframe?.contentWindow) this.$refs.iframe.contentWindow.postMessage(message, '*');

				this.log(message);

				this.processFrameSize();

			},
			sendToIFrameSetting(settingCodename, value) {

				let settingProps = Settings.getSettingProps(settingCodename);
				if (!settingProps) return;

				let message = null;

				if ((Creative.SelectedCreative.type === 'playable' || Creative.SelectedCreative.type === 'end-card' || Creative.SelectedCreative.type === 'banner' || Creative.SelectedCreative.type === 'storyboard' || Creative.SelectedCreative.type === 'editable-playable') && settingProps.options["autoApplyChanges"]) {

					message = {
						setSettings: {}
					};

					message.setSettings[settingCodename] = value;

				}

				if (this.$refs.iframe && message) {

					this.$refs.iframe.contentWindow.postMessage(message, '*');

					this.log(message);

				}

			},
			sendToIFrameLocalizationMessage(locale, codename, text_message) {

				let message = {
					setLocalizationMessage: [locale, codename, text_message]
				};

				this.$refs.iframe.contentWindow.postMessage(message, '*');

				this.log(message);

			},
			sendToIFrameLocalizationStyle(locale, codename, style_name, style_value) {

				let message = {
					setLocalizationStyle: [locale, codename, style_name, style_value]
				};

				this.$refs.iframe.contentWindow.postMessage(message, '*');

				this.log(message);

			},
			sendToIFramePreviewSize(sizes = null) {

				// Список размеров передаём, когда он изменился (в дашборде добавили или удалили размер),
				// чтобы превью пересчитало подходящий размер по актуальному списку
				let message = {
					SetSize: Layout.getPreviewSize(),
					SetSizeKey: Layout.getPreviewSizeKey()
				};

				if (sizes) message.SetSizes = sizes;

				this.$refs.iframe.contentWindow.postMessage(message, '*');

				this.log(message);

			},
			sendToIFrameElements() {

				// if (!Version.SelectedVersion?.id) return;
				if (!Version.SelectedVersion) return;

				let message = {
					SetElements: Elements.getVersionElements(Version.SelectedVersion)
				};

				this.$refs.iframe.contentWindow.postMessage(message, '*');

				this.log(message);

			},
			log() {

				console.info(`%c>>> SEND TO IFRAME >>`, 'color: #c06dd1', ...arguments);

			}
		}
	}
</script>

<style lang="sass">

	.preview-screen
		display: flex
		width: 100%
		height: 100%
		text-align: center
		justify-content: center
		cursor: default
		position: relative
		overflow: hidden

		&.is-dragging
			cursor: grab
			user-select: none

		.copy-settings
			position: absolute
			top: 0
			right: 0
			width: 150px

		.rotate-message
			color: #73818f
			font-size: 12px
			font-family: Arial, sans-serif
			margin-top: 10px
			cursor: default

		.preview-frame
			display: block
			position: relative
			border: none
			box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.27), 0px 0px 7px rgba(0, 0, 0, 0.27)
			background-color: #cccccc
			transform-origin: center

			.preview-ctrl-overlay
				position: absolute
				top: 0
				left: 0
				width: 100%
				height: 100%
				z-index: 50
				background: rgba(15, 23, 42, 0.72)
				backdrop-filter: blur(2px)
				cursor: grab
				user-select: none
				transition: opacity 0.15s ease-in-out

				&:active
					cursor: grabbing

			.preveiew-overlays
				position: absolute
				width: 100%
				height: 100%
				top: 0
				left: 0
				pointer-events: none

				.iphone-x
					width: 100%
					height: 100%
					background: url("../../../public/Images/Screens/Preview/iphonex-mocap.png") no-repeat center / contain
					transform: scale(1.13)
					filter: drop-shadow(2px 2px 5px #222)

				.iphone-x.landscape
					background: url("../../../public/Images/Screens/Preview/iphonex-mocap-landscape.png") no-repeat center / contain

		.preview-ctrl-instructions
			position: absolute
			top: 0
			left: 0
			width: 100%
			height: 100%
			z-index: 100
			display: flex
			align-items: center
			justify-content: center
			pointer-events: none
			user-select: none
			transition: opacity 0.15s ease-in-out

			.overlay-instruction
				display: flex
				flex-direction: row
				align-items: center
				gap: 16px
				padding: 10px 20px
				background: rgba(0, 0, 0, 0.65)
				border: 1px solid rgba(255, 255, 255, 0.18)
				border-radius: 8px
				box-shadow: 0 4px 20px rgba(0, 0, 0, 0.45)
				pointer-events: none

				.instruction-item
					display: flex
					align-items: center
					gap: 10px
					color: #ffffff

					.instruction-icon
						display: flex
						align-items: center
						justify-content: center
						width: 26px
						height: 26px
						color: #20a8d8
						font-size: 18px

						svg.mouse-icon
							width: 24px
							height: 24px

					.instruction-text
						font-size: 13px
						font-weight: 500
						letter-spacing: 0.3px
						white-space: nowrap
						color: rgba(255, 255, 255, 0.92)

				.instruction-divider
					width: 1px
					height: 22px
					background: rgba(255, 255, 255, 0.2)

		.no-version
			display: inline-block
			align-items: center
			justify-content: center
			border: none
			transform-origin: left

			.text
				width: 100%
				height: 100%
				display: flex
				align-items: center
				justify-content: center
				color: var(--gray)

	.preview-screen.mobile

		.device-control
			display: none

		.rotate-message
			display: none

		.preview-frame
			border: none
			position: fixed
			left: 0
			top: 0
			z-index: 10000

	.sub-aside-menu-show .preview-screen

			.controls
				width: calc(100% - 130px + 300px)

</style>

